module.exports = __webpack_public_path__ + "static/img/product14-1.02ed41ae.png";